// extracted by mini-css-extract-plugin
export default {"mainimage":"Hero_mainimage__BdeG0","mainimagemobile":"Hero_mainimagemobile__eUGyG"};